var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loading.status)?_c('div',[_c('div',{attrs:{"id":"app-loader"}},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}}),_c('small',[_vm._v(_vm._s(_vm.$store.state.loading.msg))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }